import React from 'react';
import { useSpring, animated } from 'react-spring';
import Images from '../../constants/Images';
import { useTranslation } from 'react-i18next';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import "./faq.css"

const Faq = () => {
    const { t } = useTranslation();

    const fade = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 },
        config: { duration: 1000 }
    });

    const faqs = [
        { question: 'Question1', answer: 'Question1Description' },
        { question: 'Question2', answer: 'Question2Description' },
        { question: 'Question3', answer: 'Question3Description' },
        { question: 'Question4', answer: 'Question4Description' },
        { question: 'Question5', answer: 'Question5Description' },
        { question: 'Question6', answer: 'Question6Description' },
        { question: 'Question7', answer: 'Question7Description' },
        { question: 'Question8', answer: 'Question8Description' },
        { question: 'Question9', answer: 'Question9Description' },
        { question: 'Question10', answer: 'Question10Description' },
        { question: 'Question11', answer: 'Question11Description' },
        { question: 'Question12', answer: 'Question12Description' },
        { question: 'Question13', answer: 'Question13Description' },
        { question: 'Question14', answer: 'Question14Description' },
        { question: 'Question15', answer: 'Question15Description' },
        { question: 'Question16', answer: 'Question16Description' },
        { question: 'Question17', answer: 'Question17Description' },
    ];

    return (
        <div>
            <div className="beneficiary">
                <div className="overlay-text">{t('FAQ')}</div>
            </div>
            <section className="about_section layout_padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-6">
                            <animated.div className="detail-box" style={fade}>
                                <h5>{t('claimsDeclaration')}</h5>
                                <hr className='my-2' style={{ width: '20%', height: '2%', backgroundColor: 'green', marginBottom: '10px' }} />
                                <p className='' style={{ fontFamily: 'Light Italic', fontSize: '20px' }}>{t('ClaimsDeclarationDescription')}</p>
                            </animated.div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <animated.div className="img-box" style={fade}>
                                <img src={Images.Image4} alt="Techcare" style={{ width: '100%', height: '10%' }} />
                            </animated.div>
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: '100px' }}>
                        <div className="col-lg-4 col-md-6">
                            <animated.div className="img-box" style={fade}>
                                <img src={Images.FamPic} alt="Techcare"/>
                            </animated.div>
                        </div> 
                        <div className="col-lg-8 col-md-6">
                            <animated.div className="detail-box" style={fade}>
                                <h5 style={{marginTop:"20px"}}>{t('AddBeneficiary')}</h5>
                                <hr className='my-2' style={{ width: '20%', height: '2%', backgroundColor: 'green', marginBottom: '10px' }} />
                                <p className='' style={{ fontFamily: 'Light Italic', fontSize: '20px' }}>{t('ClaimsDeclarationDescription')}</p>
                            </animated.div>
                        </div>
                    </div>
                    <div className="row" style={{ marginTop: '100px' }}>
                        <div className="col-lg-12">
                            <animated.div className="detail-box" style={{ marginTop: '35px', ...fade }}>
                                <h2 className="section-title mt-2 text-center" style={{ fontSize: '30px', fontFamily: 'Light Italic' }}>{t('FrequentlyAskedQuestions')}</h2>
                                {faqs.map((faq, index) => (
                                    <Accordion key={index}>
                                        <AccordionSummary
                                            expandIcon={<ArrowDownwardIcon />}
                                            aria-controls={`panel${index + 1}-content`}
                                            id={`panel${index + 1}-header`}
                                        >
                                            <Typography>{t(faq.question)}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography>{t(faq.answer)}</Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                ))}
                            </animated.div>
                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Faq;
